<template>
    <b-btn variant="primary" size="sm" @click.prevent="onAdminSettings" title="Configuración">
        <i class="fas fa-cogs"></i>
    </b-btn>
</template>
<script>
export default {
    methods: {
        onAdminSettings() {
            this.$router.push({
                name: 'adminSettings',
                params: {
                    venueId: this.currentVenue.id,
                },
            })
        },
    },
}
</script>

<style></style>
